// src/stone/illustrations/FreeMachineIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var FreeMachineIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 39 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#008E5A",
          d: "M34.522 12.669c-1.496 1.99-4.643 4.853-5.915 6.804l-2.178 3.785v.001l-8.903 15.476c-.657 1.005-1.99 1.454-2.98 1.002L8.592 37.02l5.358-11.421L24.799 2.482l8.242 3.76c2.413 1.102 3.077 3.98 1.482 6.427"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m20.31 23.103 1.796 7.67-4.581 7.963c-.656 1.004-1.99 1.453-2.98 1L8.59 37.02z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m14.037 36.775 14.975-32.37-8.88-4.052c-2.199-1.003-5.176.216-6.279 2.572L.693 31.428c-.438.946-.11 1.938.772 2.34l9.429 4.302c1.102.504 2.595-.112 3.143-1.295"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m27.54 3.733 5.68 2.591c-2.199-1.002-5.176.217-6.279 2.572L26.257 5.7z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m13.082 35.674 2.304-5.097c.201-.436.022-.907-.422-1.11l-8.78-4.005c-.549-.25-1.266.01-1.515.548l-2.303 5.097c-.202.436-.022.907.421 1.11l8.78 4.006c.55.25 1.266-.01 1.515-.549M23.128 13.764a.1.1 0 0 1-.047-.01L12.483 8.917a.11.11 0 0 1-.055-.147.113.113 0 0 1 .148-.055l10.598 4.835c.056.026.08.092.056.148a.11.11 0 0 1-.102.065"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m11.82 36.262-9.16-4.18a.82.82 0 0 1-.406-1.087L4.7 25.687a.826.826 0 0 1 1.092-.404l9.16 4.18a.82.82 0 0 1 .407 1.086l-2.447 5.309a.825.825 0 0 1-1.093.404M15.358 28.588l-9.16-4.18a.82.82 0 0 1-.406-1.086l5.824-12.636a.826.826 0 0 1 1.093-.404l9.16 4.18a.82.82 0 0 1 .407 1.086L16.45 28.184a.826.826 0 0 1-1.094.404"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m24.625 11.096 1.75-3.439c.398-.782-.005-1.702-.931-2.125l-7.582-3.46c-1.057-.482-2.361-.127-2.816.765"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#008E5A",
          d: "M24.625 11.207a.11.11 0 0 1-.1-.162l1.75-3.438a1.25 1.25 0 0 0 .067-1.005c-.145-.413-.48-.757-.945-.97l-7.582-3.458c-.998-.455-2.244-.122-2.67.713a.113.113 0 0 1-.15.049.11.11 0 0 1-.05-.15c.486-.953 1.842-1.326 2.962-.815l7.583 3.46c.52.237.898.628 1.064 1.098.137.392.11.81-.078 1.179l-1.75 3.438a.11.11 0 0 1-.1.06"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m11.313 30.269 1.073-2.328-.203-.093-1.073 2.328-3.35-1.528 1.073-2.329-.203-.092-1.073 2.329-3.682-1.68-.094.201 3.683 1.68-1.076 2.334-3.682-1.68-.093.203 3.682 1.68-1.143 2.48.203.092 1.142-2.48 3.351 1.528-1.143 2.48.202.093 2.313-5.016 3.697 1.687.093-.203zm-1.372 2.444-3.35-1.529 1.076-2.334 3.35 1.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M22.471 30.249a.11.11 0 0 1-.11-.094l-1.184-7.168a.11.11 0 0 1 .092-.127c.06-.01.119.031.128.092l1.185 7.168a.11.11 0 0 1-.11.129M38.5 31.357a8.6 8.6 0 0 1-.481 2.833q-.09.264-.204.522-.063.157-.14.315a8 8 0 0 1-.42.779A8.68 8.68 0 0 1 29.816 40h-3.145l-.03-9.878-.025-6.443h.786l5.945-.23q.188.084.374.177.322.159.624.346-3.019.145-6.039.292c-.248.012-.244.398.006.386l6.575-.32.066.049a8.62 8.62 0 0 1 3.377 5.25 8.8 8.8 0 0 1 .17 1.728"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M34.801 34.393c-1.694 4.466-6.702 6.726-11.185 5.05a8.6 8.6 0 0 1-3.03-1.925 8.6 8.6 0 0 1-1.79-2.543l2.07-1.56a6 6 0 0 1-.251-.93l-2.16 1.629a9 9 0 0 1-.164-.547l.028-.017 2.16-1.629.03-.482s-.172.126-.253.188l-2.06 1.552a8.585 8.585 0 0 1 .355-4.82q.008-.02.015-.04c1.228-3.235 4.194-5.312 7.44-5.575q.302-.025.609-.028l3.183-.004h.042a8.7 8.7 0 0 1 3.033.544q.24.09.474.194l-2.904.112q.517.246.987.55l2.915-.14q.004 0 .006.003.278.168.536.355l-2.942.143a8.6 8.6 0 0 1 2.35 2.717 8.58 8.58 0 0 1 .506 7.203"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "m22.72 35.283 8.836-6.656a5.5 5.5 0 0 0-1.538-1.74zm0 0a5.5 5.5 0 0 1-1.261-1.95m1.262 1.95-1.262-1.95m0 0a6 6 0 0 1-.125-.364l8.362-6.301q.165.105.322.22z"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "free-machine_Illustration_svg__a", fill: "#fff", children: /* @__PURE__ */ jsx("path", { d: "M18.455 34.114q.053.159.111.313.106.278.23.548l2.07-1.56a6 6 0 0 1-.252-.929z" }) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "M18.455 34.114q.053.159.111.313.106.278.23.548l2.07-1.56a6 6 0 0 1-.252-.929z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m18.455 34.114-.602-.798-.578.435.233.685zm.111.313-.937.35.002.004zm.23.548-.908.418.518 1.129.992-.748zm2.07-1.56.602.8.587-.444-.248-.693zm-.252-.929.983-.185-.298-1.583-1.286.97zm-3.106 1.95q.06.174.121.34l1.874-.699q-.054-.143-.102-.284zm.123.345q.12.314.257.612l1.817-.835a8 8 0 0 1-.203-.484zm1.767.993 2.07-1.56-1.204-1.597-2.07 1.56zm2.409-2.696q-.135-.376-.21-.777l-1.965.37q.103.55.292 1.082zm-1.794-1.39-2.16 1.628 1.203 1.597 2.16-1.628z",
          mask: "url(#free-machine_Illustration_svg__a)"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "free-machine_Illustration_svg__b", fill: "#fff", children: /* @__PURE__ */ jsx("path", { d: "m18.455 34.114.005.015z" }) }),
      /* @__PURE__ */ jsx("path", { fill: "#FCFCFC", d: "m18.455 34.114.005.015z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m18.455 34.114.962-.274-.208-.726h-.754zm.005.015-.92.394 1.881-.669zm-.006-.015v-1H17.13l.364 1.275zm-.96.275.005.018.003.009v-.002l-.004-.01 1.923-.55-.005-.018-.003-.008v.001l.004.01zm1.885-.654a1 1 0 0 1 .037.105l-1.923.549q.014.052.048.134zm-.925 1.38h.001v-2z",
          mask: "url(#free-machine_Illustration_svg__b)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M26.31 35.392a3 3 0 0 1-.992-.177c-1.23-.439-1.878-1.73-1.794-2.723a.11.11 0 0 1 .12-.101c.062.005.108.059.103.12-.078.91.517 2.092 1.646 2.496.814.29 1.654.189 2.247-.27.449-.349.676-.855.624-1.393-.1-1.013-.726-1.457-1.521-2.019l-.073-.051c-.812-.576-1.487-1.124-1.517-2.015a1.72 1.72 0 0 1 .729-1.471c.573-.416 1.368-.502 2.127-.23.904.322 1.397 1.121 1.555 1.761a.11.11 0 0 1-.081.135.11.11 0 0 1-.136-.081c-.145-.584-.593-1.313-1.415-1.606-.699-.25-1.399-.177-1.92.2a1.5 1.5 0 0 0-.637 1.285c.027.79.634 1.282 1.424 1.841l.072.051c.808.572 1.505 1.065 1.614 2.18.06.614-.198 1.194-.708 1.588-.41.316-.923.48-1.468.48"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M24.995 36.073a.111.111 0 0 1-.106-.149l3.296-9.169a.112.112 0 0 1 .21.075L25.1 36a.11.11 0 0 1-.105.073"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "free-machine_Illustration_svg__c", fill: "#fff", children: /* @__PURE__ */ jsx("path", { d: "m20.508 31.439-.029.482-2.16 1.629-.028.017a7 7 0 0 1-.095-.389l2.06-1.551c.081-.062.252-.188.252-.188" }) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m20.508 31.439-.029.482-2.16 1.629-.028.017a7 7 0 0 1-.095-.389l2.06-1.551c.081-.062.252-.188.252-.188"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m20.508 31.439.998.06.13-2.144-1.724 1.28zm-.029.482.602.798.368-.278.028-.46zm-2.16 1.629.598.801.004-.003zm-.028.017-.965.263.302 1.106 1.055-.45zm-.095-.389-.602-.798-.508.383.132.622zm2.06-1.551-.6-.8-.002.001zm-.746-.249-.03.483 1.997.12.03-.482zm.367-.256-2.16 1.63 1.204 1.596 2.16-1.629zm-2.156 1.626a1 1 0 0 1 .177-.101l.785 1.84c.116-.05.199-.11.234-.136zm1.534.555a6 6 0 0 1-.08-.331l-1.957.413q.049.23.108.445zm-.457.674 2.06-1.552-1.204-1.597-2.06 1.552zm2.058-1.55c.039-.03.1-.076.154-.115l.067-.05.02-.015.005-.004.002-.002-.596-.802-.596-.803-.002.001-.006.004-.02.016-.069.05-.16.12z",
          mask: "url(#free-machine_Illustration_svg__c)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M22.422 35.915a.11.11 0 0 1-.077-.03 6.26 6.26 0 0 1-1.584-2.432 6.18 6.18 0 0 1 .043-4.298 6.2 6.2 0 0 1 1.092-1.845.11.11 0 0 1 .157-.012.11.11 0 0 1 .013.156 6.02 6.02 0 0 0-1.095 5.923c.318.888.846 1.7 1.528 2.345a.11.11 0 0 1 .004.157.11.11 0 0 1-.081.036"
        }
      )
    ]
  }
);
var FreeMachineIllustration_default = FreeMachineIllustration;

export {
  FreeMachineIllustration_default
};
